// Libraries
import { TextField } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { ReactElement } from "react";
import ReactHtmlParser from "react-html-parser";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSEditStyle } from "./../BQSPrimitivesStyle";
import { isNullOrUndefined } from "Custom/Utils/Utils";

interface IProps {
    className?: string;
    displayName: string;
    execute: (value: string) => void;
    canExecute?: boolean;
    isPassword?: boolean;
    placeholder?: string;
    maxLength?: number;
    value: string;
    validationMessage?: string;
    fieldName?: string;
}

export const BQSEdit: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const editClasses = BQSEditStyle();

    const getClassName = (): string => {
        return classNames({
            BQSEdit: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
        });
    };

    const getDisplayName = (): ReactElement[] | string => {
        return !isEmptyOrWhitespace(props.displayName) ? ReactHtmlParser(props.displayName) : "";
    };

    const getPlaceholder = (): string => {
        return !isEmptyOrWhitespace(props.placeholder) ? props.placeholder! : "";
    };

    const getType = (): string => {
        return !isNullOrUndefined(props.isPassword) && props.isPassword ? "password" : "text";
    };

    const getValidationMessage = (): string => {
        return !isEmptyOrWhitespace(props.validationMessage) ? props.validationMessage! : "";
    };

    const getValue = (): string => {
        return props.value;
    };

    const isDisabled = (): boolean => {
        return !isNullOrUndefined(props.canExecute) ? !props.canExecute : false;
    };

    const isValidationMessageNotEmpty = (): boolean => {
        return !isEmptyOrWhitespace(props.validationMessage);
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        props.execute(event.target.value);
    };
    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <TextField
            classes={editClasses}
            className={getClassName()}
            disabled={isDisabled()}
            error={isValidationMessageNotEmpty()}
            helperText={getValidationMessage()}
            label={getDisplayName()}
            InputLabelProps={{
                shrink: true,
                variant: "standard",
            }}
            InputProps={{
                disableUnderline: true,
            }}
            onChange={onChange}
            placeholder={getPlaceholder()}
            type={getType()}
            value={getValue()}
        />
    ));

    // #endregion Render Result
};
